<template>
	<div style="padding:2px;">
		<div style=" width:1141px;margin:auto">
			<div
				style="font-size:18px;font-weight: 700;text-align: left; height:50px;line-height: 70px; border-bottom: 2px solid #ccc;margin-bottom: 6px;">
				钢材知识</div>
			<div class="mtp"
				:style="{backgroundImage:'url(' + require('../../assets/Steel/gt20230210091018.png') + ')'}"></div>
			<div style="width:1141px;line-height: 60px; margin: auto; text-align: left;">
				<h2>钢铁知识</h2>
			</div>
			<div style="width:1141px;margin: auto; display:flex; flex-direction: row;justify-content: flex-start;">
				<div style="width:360px;display:flex;flex-direction: column;justify-content: flex-start; ">
					<div class="point" style="line-height:30px;text-align: left;cursor: pointer;"
						@click="imgPointOpen(0)"><i class="el-icon-user-solid"></i>钢铁是怎样炼成的？</div>
					<div @click="imgPointOpen(1)" class="point" style="line-height:30px;text-align: left;cursor: pointer;"><i
							class="el-icon-user-solid"></i>碳素钢的定义及钢中五元素</div>
					<div @click="imgPointOpen(2)" class="point" style="line-height:30px;text-align: left;cursor: pointer;"><i
							class="el-icon-user-solid"></i>钢的力学性能</div>
					<div @click="imgPointOpen(3)" class="point" style="line-height:30px;text-align: left;cursor: pointer;"><i
							class="el-icon-user-solid"></i>不锈钢板和冷轧钢板的区别</div>
					<div @click="imgPointOpen(4)" class="point" style="line-height:30px;text-align: left;cursor: pointer;"><i
							class="el-icon-user-solid"></i>铝板、铝合金板与冷轧钢板的差别
					</div>
				</div>
				<div class="imgpoint">
				<el-dialog title=" " :visible.sync="img_dialog" width="80%" top="5vh" :show-close="false">
					<iframe :src="imgPointList[point_index]" width="100%" height="700" frameborder="0"
						allowfullscreen></iframe>
				</el-dialog>
				</div>
				<div class="video-box" style="margin-left: 10px;">
					<div class="video-img-box" style="width: 400px;height: 316px;position: relative;">
						<img style="width: 400px;height: 316px;" src="../../assets/Steel/video.png" alt="..."
							class="img-rounded">
						<video :src="url" controls loop muted autoplay></video>
					</div>
				</div>
				<div style="margin-left: 10px;margin-top: -70px;">
					<div style="height:30px;line-height:30px;">公/英制单位换算表</div>
					<el-table :data="tableData" size="mini" border style="width: 100%">
						<el-table-column prop="xm" label="项目">
						</el-table-column>
						<el-table-column prop="zd" label="制度">
						</el-table-column>
						<el-table-column prop="dw" label="单位" width="120">
						</el-table-column>
						<el-table-column prop="hsgs" label="换算公式" width="180">
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div style=" width:1141px;margin: auto; display:flex; flex-direction: row;justify-content: flex-start;">
				<div style="width:660px; margin-top: 20px;">
					<div style="height:30px;line-height:30px;text-align: left;">钢板理论计重的重量计算方法</div>
					<el-table :data="tableData2" size="mini" border style="width: 100%">
						<el-table-column prop="sx" label="计算顺序">
						</el-table-column>
						<el-table-column prop="ff" width="240" label="计算方法">
						</el-table-column>
						<el-table-column prop="jgxy" width="130" label="结果的修约">
						</el-table-column>
					</el-table>
				</div>
				<div style=" margin-left: 10px;margin-top: 20px;">
					<div style="height:30px;line-height:30px;text-align: left;">钢板理重或理长计算器</div>
					<el-tabs v-model="activeName" type="border-card">
						<el-tab-pane label="理论重量" name="first">
							<el-form size="mini" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"
								class="demo-ruleForm">
								<el-form-item label="厚度" prop="hd1">
									<el-input  type="number" v-model="ruleForm.hd">
										<template slot="append">mm</template>
									</el-input>
								</el-form-item>
								<el-form-item label="宽度" prop="kd1">
									<el-input  type="number" v-model="ruleForm.kd">
										<template slot="append">mm</template>
									</el-input>
								</el-form-item>
								<el-form-item label="长度" prop="cd1">
									<el-input  type="number" v-model="ruleForm.cd">
										<template slot="append">mm</template>
									</el-input>
								</el-form-item>
								<el-form-item label="数量" prop="sl1">
									<el-input v-model.number="ruleForm.sl">
										<template slot="append">张</template>
									</el-input>
								</el-form-item>
								<el-form-item style="text-align: left;">
									<el-button type="primary" @click="submitForm('ruleForm')">计算</el-button>
									<span style="margin-left: 10px;">钢材理重：{{ruleForm.res}}</span>
								</el-form-item>
							</el-form>
						</el-tab-pane>
						<el-tab-pane label="理论长度" name="second">
							<el-form size="mini" :model="ruleForm1" :rules="rules1" ref="ruleForm" label-width="100px"
								class="demo-ruleForm">
								<el-form-item label="厚度" prop="hd1">
									<el-input  type="number" v-model="ruleForm1.hd">
										<template slot="append">mm</template>
									</el-input>
								</el-form-item>
								<el-form-item label="宽度" prop="kd1">
									<el-input  type="number" v-model="ruleForm1.kd">
										<template slot="append">mm</template>
									</el-input>
								</el-form-item>
								<el-form-item label="重量" prop="zl2">
									<el-input  type="number" v-model="ruleForm1.zl" width="60">
										<template slot="append">
											<el-select v-model="ruleForm1.zldw" style="width:66px">
												<el-option label="T" value="T"></el-option>
												<el-option label="KG" value="KG"></el-option>
											</el-select>
										</template>
									</el-input>
								</el-form-item>
								<el-form-item label="数量" prop="sl1">
									<el-input  v-model.number="ruleForm1.sl">
										<template slot="append">张</template>
									</el-input>
								</el-form-item>
								<el-form-item style="text-align: left;">
									<el-button type="primary" @click="submitForm('ruleForm1')">计算</el-button>
									<span style="margin-left: 10px;">钢板理长：{{ruleForm1.res}}</span>
								</el-form-item>
							</el-form>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>

			<div style="">
				<div style="height:30px;line-height:30px;text-align: left;">标准查询</div>
			</div>

			<div style=" width:1141px;margin: auto;">
				<div style="height:30px;line-height:30px;text-align: left;">标准查询</div>
				<el-card shadow="never">
					<el-form style="text-align: left;" :inline="true" :model="formInline" class="demo-form-inline">
						<el-form-item>
							<el-select v-model="formInline.gs" placeholder="归属">
								<el-option label="国标" value="国标"></el-option>
								<el-option label="宝钢" value="宝钢"></el-option>
								<el-option label="鞍钢" value="鞍钢"></el-option>
								<el-option label="攀钢" value="攀钢"></el-option>
								<el-option label="攀钢(西昌)" value="攀钢(西昌)"></el-option>
							</el-select>
							<el-button slot="append" icon="el-icon-search"></el-button>
						</el-form-item>
						<el-form-item>
							<el-input placeholder="请输入标准号或标准名称" style="width:660px" v-model="formInline.kwd"
								clearable></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="searchData()">查询</el-button>
							<el-button @click="resetSearch">重置</el-button>
						</el-form-item>
					</el-form>
					<el-table :data="tableData3" border size="mini" style="width: 100%" v-loading="tableData3_loading">
						<el-table-column prop="id" label="序号" width="80">
						</el-table-column>
						<el-table-column prop="bzh" label="标准号" width="180">
						</el-table-column>
						<el-table-column prop="bzm" label="标准名" width="200">
						</el-table-column>
						<el-table-column prop="gs" label="归属">
						</el-table-column>
						<el-table-column prop="publishTime" label="发布日期">
						</el-table-column>
						<el-table-column prop="implementTime" label="实施日期">
						</el-table-column>
						<el-table-column prop="state" label="状态">
						</el-table-column>
						<el-table-column prop="uploadTime" label="上传时间">
						</el-table-column>
						<el-table-column prop="look" label="浏览次数">
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<el-button type="text" @click="showPDF(scope.$index, scope.row)">查看</el-button>
							</template>
						</el-table-column>
					</el-table>
					<el-pagination style="float:left;margin-top:20px" @size-change="handleSizeChange"
						@current-change="handleCurrentChange" :current-page="currentPage4" :page-sizes="pageSizes"
						:page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</el-card>
			</div>

		</div>
		<div
			style="width:100%;margin-top: 10px; background-color: #efefef;text-align: center; height: 50px;line-height: 50px;border-top: 1px solid #ccc; margin-bottom: 2px;">
			2022 重庆市离离科技有限公司 备案 渝ICP备2020011628号-1
		</div>
	</div>
</template>

<script>
	import videourl from '../../assets/Steel/炼钢视频.mp4';
	import {
		getList_api_pdfInstruction,
		look_api_pdfInstruction
	} from "@/apiOld/pdfInstruction.js";
	export default {
		data() {
			return {
				point_index: 0,
				imgPointList: [
					"https://www.liligc.com/pdfView/pdfjs/web/viewer.html?file=https://www.liligc.com/download/pdf/钢铁是怎样炼成的？.pdf",
					"https://www.liligc.com/pdfView/pdfjs/web/viewer.html?file=https://www.liligc.com/download/pdf/碳素钢的定义及钢中五元素.pdf",
					"https://www.liligc.com/pdfView/pdfjs/web/viewer.html?file=https://www.liligc.com/download/pdf/钢的力学性能.pdf",
					"https://www.liligc.com/pdfView/pdfjs/web/viewer.html?file=https://www.liligc.com/download/pdf/不锈钢板和冷轧钢板的区别.pdf",
					"https://www.liligc.com/pdfView/pdfjs/web/viewer.html?file=https://www.liligc.com/download/pdf/铝板、铝合金板与冷轧钢板的差别.pdf",
				],
				img_dialog: false,
				url: videourl,
				tableData: [{
						xm: '强度',
						zd: '公制',
						dw: 'MPa',
						hsgs: '1 KSI = 7 MPa'
					},
					{
						xm: '强度',
						zd: '英制',
						dw: 'KSI',
						hsgs: '1 KSI = 7 MPa'
					},
					{
						xm: '强度',
						zd: '公制',
						dw: 'mm',
						hsgs: '1 in = 25.4 mm'
					},
					{
						xm: '强度',
						zd: '英制',
						dw: 'in',
						hsgs: '1 in = 25.4 mm'
					},
					{
						xm: '强度',
						zd: '公制',
						dw: 'm',
						hsgs: '1 ft = 0.30 m'
					},
					{
						xm: '强度',
						zd: '英制',
						dw: 'ft',
						hsgs: '1 ft = 12 in'
					},
					{
						xm: '重量',
						zd: '公制',
						dw: 'kg',
						hsgs: '1 pound = 0.45 kg'
					},
					{
						xm: '重量',
						zd: '英制',
						dw: 'pound',
						hsgs: '1 pound = 0.45 kg'
					},
					{
						xm: '重量',
						zd: '公制',
						dw: 'g',
						hsgs: '1 oz = 28.35 g'
					},
					{
						xm: '重量',
						zd: '英制',
						dw: 'oz',
						hsgs: '1 oz = 28.35 g'
					},
					{
						xm: '重量',
						zd: '公制',
						dw: 'g/m2',
						hsgs: '1oz/ft2=305.16g/m2'
					},
					{
						xm: '重量',
						zd: '英制',
						dw: 'oz/ft2',
						hsgs: '1oz/ft2=305.16g/m2'
					}
				],
				tableData2: [{
						sx: '基本重量/【kg/（mm.m2】',
						ff: '7.85kg(厚度1mm.面积1m2的重量)',
						jgxy: '-'
					},
					{
						sx: '单位重量/kg/m2',
						ff: '基本重量/【kg/(mm.m2)】X厚度(mm)',
						jgxy: '修约到有效数字4位'
					},
					{
						sx: '一张钢板的重量/kg',
						ff: '单位重量(kg/m2) X 面积(m2)',
						jgxy: '修约到有效数字3位'
					},
					{
						sx: '* 适用于冷轧无镀层、电镀锡及电镀铬等产品。',
						ff: '',
						jgxy: ''
					}
				],
				tableData3: [],
				tableData3_loading: false,
				currentPage4: 1,
				pageSizes: [10, 20, 30, 40],
				pageSize: 10,
				total: 0,
				activeName: 'first',
				ruleForm: {
					hd: 0.0,
					kd: 0.0,
					cd: 0.0,
					sl: 0
				},
				rules: {
					hd: [{
						required: true,
						message: '请输入厚度',
						trigger: 'blur'
					}],
					kd: [{
						required: true,
						message: '请输入宽度',
						trigger: 'blur'
					}],
					cd: [{
						required: true,
						message: '请输入长度',
						trigger: 'blur'
					}],
					sl: [{
						required: true,
						message: '请输入数量',
						trigger: 'blur'
					}]
				},
				ruleForm1: {
					hd: 0,
					kd: 0,
					zl: 0,
					sl: 0,
					zldw: 'T'
				},
				rules1: {
					hd: [{
						required: true,
						message: '请输入厚度',
						trigger: 'blur'
					}],
					kd: [{
						required: true,
						message: '请输入宽度',
						trigger: 'blur'
					}],
					zl: [{
						required: true,
						message: '请输入重量',
						trigger: 'blur'
					}],
					sl: [{
						required: true,
						message: '请输入数量',
						trigger: 'blur'
					}]
				},
				formInline: {
					gs: '',
					kwd: ''
				},
				searchForm: {},
				isSearch: false,
			};
		},
		mounted() {
			this.getPdfList();
		},
		methods: {
			submitForm(type) {
				if (type == 'ruleForm') {
					let a = this.ruleForm.hd;
					let b = this.ruleForm.cd;
					let c = this.ruleForm.kd;
					let d = this.ruleForm.sl;
					if (!a || !b || !c || !d) {
						alert("请填写正确的数据");
						return
					}
					let num = a * b * c * d * 7.85 / 1000000000;
					let kg = num * 1000;
					this.ruleForm.res = kg.toFixed(3) + "KG";
				} else {
					let a = this.ruleForm1.hd;
					let c = this.ruleForm1.kd;
					let d = this.ruleForm1.sl;
					let e = this.ruleForm1.zl;
					if (!a || !e || !c || !d) {
						alert("请填写正确的数据");
						return
					}
					if (this.ruleForm1.zldw == 'KG') {
						e = e / 1000;
					}
					let num = e * 1000000000 / (a * c * d * 7.85);
					this.ruleForm1.res = num.toFixed(4) + "mm";
				}
				this.$forceUpdate();
			},
			imgPointOpen(index){
				this.point_index = index;
				this.img_dialog = true;
			},
			searchData(pageData) {
				if (!this.formInline.kwd && !this.formInline.gs) {
					this.$message.warning("请输入任意搜索值或选择归属");
					return;
				}
				this.isSearch = true;
				let page_data = {
					page_size: this.pageSize,
					current_page: 1,
				};
				if (pageData) {
					page_data = pageData;
				}
				let condition = {};
				if (this.formInline.kwd) {
					var reg = /.*[\u4e00-\u9fa5]+.*$/;
					if (reg.test(this.formInline.kwd)) {
						condition['bzm'] = {
							"value": this.formInline.kwd
						};
					} else {
						condition['bzh'] = {
							"value": this.formInline.kwd
						};
					}
				}

				if (this.formInline.gs) {
					condition['gs'] = {
						"value": this.formInline.gs
					};
				}

				this.getPdfList(page_data, condition);
			},
			resetSearch() {
				this.searchForm = {};
				this.currentPage4 = 1;
				this.getPdfList();
				this.isSearch = false;
			},
			showPDF(index, row) {
				row.look++;
				this.lookCount(row.id);
				var urlPre = "https://www.liligc.com/pdfView/pdfjs/web/viewer.html?file=" + row.file;
				window.open(urlPre);
			},
			handleSizeChange(page_size) {
				this.pageSize = page_size;
				this.currentPage4 = 1;
				this.getPdfList();
			},
			handleCurrentChange(click_page) {
				this.currentPage4 = click_page;
				this.getPdfList();
			},
			lookCount(id) {
				let sendData = {
					lookId: id,
					serverType: 3
				};
				look_api_pdfInstruction(sendData);
			},
			async getPdfList(page_data, condition) {
				this.tableData3_loading = true;
				this.tableData3 = [];
				let sendData = {
					pn: this.currentPage4,
					rn: this.pageSize,
					condition: {},
					serverType: 3
				};
				if (page_data) {
					sendData.pn = page_data.current_page;
					sendData.rn = page_data.page_size;
				}
				if (condition) {
					sendData.condition = Object.assign(sendData.condition, condition);
				}
				sendData.condition = JSON.stringify(sendData.condition);
				let res = await getList_api_pdfInstruction(sendData);
				res = res.data;
				if (res.success === true) {
					this.tableData3 = res.dataList.list;
					this.total = res.dataList.total;
				}
				this.tableData3_loading = false;
			},
		},
	};
</script>

<style lang="less" scoped>
	.myvideo {
		width: 400px;
		height: 316px;
		position: relative;

	}

	.video-box {
		padding: 0 0;
		position: relative;
	}

	.video-box img {
		margin-top: -60px;
	}

	.video-img-box video {
		position: absolute;
		width: 370px;
		top: -50px;
		left: 3.6%;
		background-color: #000000;
		padding-bottom: 4.1%;
	}

	.mtp {
		height: 494px;
		width: 1141px;
		margin: auto;
	}

	.point {
		cursor: pointer;
	}

	.point:hover {
		color: #0000ff;
	}
	.imgpoint /deep/ .el-dialog__header{
		padding: 0;
	}
	.imgpoint /deep/ .el-dialog__body{
		padding: 0;
	}
</style>